define('core/views/common/mixins/LocalScroll',[
], function (
) {
    'use strict';

    // LocalScroll mixin prevent scrolling outside area user is in currently.
    // To be used via utils/mixin
    var LocalScroll = {
        events: {
            'mousewheel': 'handleScrollEvent', // Chrome, IE, Safari version
            'wheel': 'handleScrollEvent', // FF version
        },

        // selector for the element which contain scrollable content.
        // content should hold the whole necessary width for it, i.e. no
        // overflow:scroll
        scrollMeasureSelector: '',

        getScrollMeasure: function () {
            if (!this.scrollMeasure) {
                this.scrollMeasure = this.$el;
                if (this.scrollMeasureSelector)
                    this.scrollMeasure = this.$el.find(this.scrollMeasureSelector);
            }
            return this.scrollMeasure;
        },

        // prevent user to scroll in parent container while in the view
        // TODO: implement the same logic for scrolling via keyboard
        handleScrollEvent: function (evt) {
            // if dir is greater than 0 - means direction up and
            // if dir is less than 0 - user scrolling down
            var event = evt.originalEvent;
            var dir = event.wheelDeltaY || -event.deltaY;

            var el = this.$el;
            var height = el.height(); // height of visible area
            var measure = this.getScrollMeasure(); // measures scrollable content area height
            var scrollHeight = measure.height(); // height of inner content
            var scrollTop = measure.parent()[0].scrollTop; // current position of the scroll
            var isBottom = scrollTop >= scrollHeight - height;
            var isTop = scrollTop === 0;

            if ((isBottom && dir < 0) || (isTop && dir > 0))
                evt.preventDefault();
        },
    };

    return LocalScroll;
});

